<template>
  <div style="background: white" id="myDivCalen">
    <div class="inner-div1">
      <br />
      <!-- <pre>{{ lastestData }}</pre> -->
      <vs-row class="al-center" vs-w="12">
        <vs-col
          vs-type="flex"
          style="margin: 10px; background: #fff; border-radius: 40px"
          vs-align="center"
          vs-lg="5"
          vs-sm="4"
          vs-xs="4"
        >
          <img
            style="position: relative; width: 20%"
            src="@/assets/images/logo/Untitled design (2).png"
          />
          <h1 class="mt-1 mb-1">
            <b>Building A</b>
          </h1> </vs-col
        ><vs-spacer />
        <vs-icon
          v-if="showIcon"
          class="cursor-pointer"
          @click="hideSideBar('myDivCalen')"
          icon="zoom_out_map"
          size="25px"
          color="#6c757d"
        ></vs-icon>
        <vs-icon
          v-else
          class="cursor-pointer"
          @click="showSideBar"
          icon="zoom_in_map"
          size="25px"
          color="#6c757d"
        ></vs-icon> </vs-row
      ><br />
      <vs-row vs-w="12">
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="3"
          vs-sm="4"
          vs-xs="12"
        >
          <div style="position: relative; width: 100%; left: 0; top: 0">
            <img
              style="position: relative; width: 100%"
              :src="color_aqi[aqi_mode].img"
            />
            <div
              class="container text-center"
              style="
                position: absolute;
                margin: auto;
                top: 0px;
                display: flex;
                bottom: 0px;
                width: 50%;
                right: 0px;
                flex-direction: column;
                justify-content: center;
              "
            >
              <div>
                <h1
                  style="font-weight: 800; font-size: 3.5vw"
                  :style="{ color: color_aqi[aqi_mode].color }"
                >
                  {{ parseInt(lastestAQI) }}
                </h1>
              </div>
              <div class="mb-1"><h2 style="font-weight: 800">AQI</h2></div>
              <div>
                <img
                  style="width: 50px; height: 50px"
                  src="@/assets/images/Enco/AQIULogo.png"
                />
              </div>
            </div>
          </div>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="4"
          vs-sm="4"
          vs-xs="12"
        >
          <div
            style="position: relative"
            :style="{ background: color_aqi[aqi_mode].bg }"
            class="bg-div2 opacityCard"
          >
            <br />
            <div
              style="
                position: absolute;
                top: 25%;
                left: 0;
                right: 0;
                margin-left: auto;
                margin-right: auto;
              "
            >
              <ul>
                <h1 style="font-weight: 600; font-size: 2rem">AIR QUALITY</h1>
              </ul>
            </div>
            <div
              style="
                position: absolute;
                top: 50%;
                left: 0;
                right: 0;
                margin-left: auto;
                margin-right: auto;
              "
            >
              <ul>
                <h1
                  style="font-weight: 800"
                  :style="{
                    color: color_aqi[aqi_mode].color,
                    'font-size': color_aqi[aqi_mode].fontsize,
                  }"
                >
                  {{ color_aqi[aqi_mode].text }}
                </h1>
              </ul>
            </div>
          </div>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="5"
          vs-sm="4"
          vs-xs="12"
        >
          <div style="height: 100%" class="container-fluid">
            <vs-row class="a opacityCard">
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-lg="3"
                vs-sm="4"
                vs-xs="2"
              >
                <img
                  style="width: 80%; height: 80%"
                  src="@/assets/images/Enco/7813236.png"
                />
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-lg="4"
                vs-sm="4"
                vs-xs="3"
              >
                <h1 style="font-weight: 800; color: #1f6106; font-size: 3rem">
                  {{ lastestData }}
                </h1>
                <p class="ug-detail ml-1">µg./m3</p>
              </vs-col>
              <vs-col vs-lg="5" vs-sm="4" vs-xs="6">
                <LineChartSmall
                  :width="50"
                  :height="70"
                  :getRandomInt="getRandomInt"
                  color="#1f6106"
                ></LineChartSmall>
              </vs-col>
            </vs-row>
            <br />
            <vs-row class="b opacityCard">
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-lg="3"
                vs-sm="4"
                vs-xs="12"
              >
                <img
                  style="width: 88%; height: 80%"
                  src="@/assets/images/Enco/Untitled-1xzc.png"
                />
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-lg="4"
                vs-sm="4"
                vs-xs="12"
              >
                <h1 style="font-weight: 800; color: #1f6106; font-size: 3rem">
                  {{ lastestDatapm10 }}
                </h1>
                <p class="ug-detail ml-1">µg./m3</p>
              </vs-col>
              <vs-col
                vs-lg="5"
                style="position: relative; width: 100%"
                vs-sm="4"
                vs-xs="12"
              >
                <LineChartSmall
                  :width="50"
                  :height="70"
                  :getRandomInt="getRandomInt"
                  color="#1f6106"
                ></LineChartSmall>
              </vs-col>
            </vs-row>
          </div>
        </vs-col> </vs-row
      ><br />
      <vs-row vs-w="12">
        <vs-card style="opacity: 0.75; border-radius: 20px" class="w">
          <vs-row class="mt-3">
            <h3 style="font-weight: 600">PM2.5 Timeseries</h3>
            <vs-spacer />
            <vs-select
              class="selectExample"
              @change="selectDataA(selectData, index)"
              v-model="selectData"
            >
              <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.text"
                v-for="(item, index) in options1"
              />
            </vs-select> </vs-row
          ><br />

          <vs-row style="display: flex; align-items: center" vs-w="12">
            <div style="position: relative; width: 100%">
              <BarChart
                :height="340"
                :chartData="datacollection"
                :options="option_power"
                :dataLabel="true"
              ></BarChart>
            </div>
          </vs-row>
        </vs-card>
      </vs-row>
      <vs-row style="margin-bottom: 0" vs-w="12">
        <lvaqi />
        <!-- <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <img style="width: 98%" src="@/assets/images/Enco/levelquality.png" />
        </vs-col> -->
      </vs-row>
    </div>

    <b-modal
      scrollable
      id="modal-settingMap"
      ref="my-modal"
      no-close-on-backdrop="false"
      hide-header
      centered
      size="lg"
    >
      <!-- <pre>{{test}}</pre> -->
      <h4
        class="mb-4 colorSuccess"
        style="font-size: 1.125rem; font-weigth: 500"
      >
        Comparison settings
      </h4>
      <br />
      <vs-row>
        <vs-select
          class="selectExample"
          label="Select Duration"
          v-model="selectDataCompare1"
        >
          <vs-select-item
            :key="index"
            :value="item.value"
            :text="item.text"
            v-for="(item, index) in optionsCompare1"
          />
        </vs-select> </vs-row
      ><br />
      <vs-row>
        <vs-select
          class="selectExample"
          label="Compare"
          v-model="selectDataCompare2"
        >
          <vs-select-item
            :key="index"
            :value="item.value"
            :text="item.text"
            v-for="(item, index) in optionsCompare2"
          /> </vs-select
        ><vs-select
          class="selectExample ml-2"
          label="Yearly"
          v-model="selectDataYearly"
        >
          <vs-select-item
            :key="index"
            :value="item.value"
            :text="item.text"
            v-for="(item, index) in optionsCompareYearly"
          /> </vs-select
      ></vs-row>
      <template #modal-footer>
        <vs-button
          class="brdbtn"
          color="success"
          @click="fillData"
          type="filled"
          >Submit</vs-button
        >
        <vs-button
          class="brdbtn"
          color="dark"
          @click="cancelMapsetting"
          type="flat"
          >Cancel</vs-button
        >
      </template>
    </b-modal>
  </div>
</template>

<script>
import lvaqi from "./level_aqi.vue";
import BarChart from "../../dashboard/Ajinomoto/dashboard/barchart";
import LineChartSmall from "../../Page/PM2.5/lineChart.vue";
import LineChart from "../../Page/PM2.5/Chart.js";
import moment from "moment";
export default {
  name: "App",
  components: { LineChart, LineChartSmall, BarChart, lvaqi },
  data: () => ({
    datacollection_power: {},
    option_power: {
      maintainAspectRatio: false,
      responsive: true,
      legend: {
        display: false,
        position: "bottom",
      },
      // plugins: [ChartDataLabels],
      plugins: {
        datalabels: {
          display: false,
          // color: "white",
          // textAlign: "center",
          // font: {
          //   weight: "bold",
          //   size: 16,
          // },
        },
      },
      scales: {
        yAxes: [
          {
            id: "A",
            ticks: {
              beginAtZero: true,
              steps: 5,
              stepValue: 5,
            },
            position: "left",
            scaleLabel: {
              display: true,
              labelString: "µg./m3",
            },
          },
        ],
        xAxes: [
          {
            ticks: {
              beginAtZero: true,
            },
          },
        ],
      },
    },
    lastestData: 0,
    interval: null,
    lastestAQI: 0,
    showIcon: true,
    selectDataCompare1: 3,
    selectDataCompare2: 3,
    selectDataYearly: 0,
    color_aqi: {
      lv1: {
        text: "Good",
        textth: "ดี",
        bg: "#caebbd",
        fontsize: "5rem",
        img: require("@/assets/images/Enco/aqi/2.png"),
        color: "#1b6106",
      },
      lv2: {
        text: "Moderate",
        textth: "ปานกลาง",
        img: require("@/assets/images/Enco/aqi/3.png"),
        fontsize: "5rem",
        bg: "#fbe988",
        color: "#5f6106",
      },
      lv3: {
        text: "Unhealthy",
        textth: "เริ่มมีผลต่อสุขภาพ",
        fontsize: "4rem",
        img: require("@/assets/images/Enco/aqi/4.png"),
        bg: "#ebdabd",
        color: "#613706",
      },
      lv4: {
        text: "Literally Unhealthy",
        textth: "มีผลต่อสุขภาพมาก",
        fontsize: "3.3rem",
        bg: "#ebbdbd",
        img: require("@/assets/images/Enco/aqi/5.png"),
        color: "#610e06",
      },
      lv5: {
        text: "Very Unhealthy",
        textth: "มีผลต่อสุขภาพมาก",
        fontsize: "3.3rem",
        bg: "#ddbdeb",
        img: require("@/assets/images/Enco/aqi/6.png"),
        color: "#67174F",
      },
      lv6: {
        text: "Hazardous",
        textth: "อันตรายต่อสุขภาพ",
        fontsize: "4rem",
        bg: "#ebd0bd",
        img: require("@/assets/images/Enco/aqi/7.png"),
        color: "#745726",
      },
    },
    optionsCompare1: [
      { text: "Daily", value: 0 },
      { text: "Monthly", value: 2 },
      { text: "Yearly", value: 3 },
    ],
    optionsCompare2: [
      { text: "Daily", value: 0 },
      { text: "Monthly", value: 2 },
      { text: "Yearly", value: 3 },
    ],
    optionsCompareYearly: [
      { text: "2020", value: 0 },
      { text: "2019", value: 2 },
      { text: "2018", value: 3 },
      { text: "2017", value: 2 },
      { text: "2016", value: 3 },
    ],
    dataChart1: [10, 39, 10, 40, 39, 20, 10],
    selectData: 1,
    options1: [
      {
        text: "Daily",
        value: 1,
        label: [
          "0 AM",
          "1 AM",
          "2 AM",
          "3 AM",
          "4 AM",
          "5 AM",
          "6 AM",
          "7 AM",
          "8 AM",
          "9 AM",
          "10 AM",
          "11 AM",
          "12 AM",
          "1 PM",
          "2 PM",
          "3 PM",
          "4 PM",
          "5 PM",
          "6 PM",
          "7 PM",
          "8 PM",
          "9 PM",
          "10 PM",
          "11 PM",
        ],
      },
      {
        text: "Monthly",
        value: 2,

        label: ["Week 1", "Week 2", "Week 3", "Week 4"],
      },
      {
        text: "Yearly",
        value: 3,

        label: [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ],
      },
      // {
      //   text: "Custom",
      //   value: 4,

      //   label: [
      //     "Week 1",
      //     "Week 2",
      //     "Week 3",
      //     "Week 4",
      //     "Week 5",
      //     "Week 6",
      //     "Week 7",
      //     "Week 8",
      //     "Week 9",
      //     "Week 10",
      //     "Week 11",
      //     "Week 12",
      //   ],
      // },
    ],
    height: 300,
    datacollection: null,
    gradient: null,
    chart_data: null,
    lastestDatapm10: 0,
    dailyData: [],
    monthlyData: [],
    yearlyData: [],
    height_graph: null,
  }),
  methods: {
    mapData(value, in_min, in_max, out_min, out_max) {
      return (
        ((value - in_min) * (out_max - out_min)) / (in_max - in_min) + out_min
      );
    },
    async getData() {
      var today = moment().format("YYYY-MM-DD");
      var month = moment().format("YYYY-MM");
      var year = moment().format("YYYY");

      var check = true;
      var j = 0;
      var divider = 1;
      var sum = 0;
      await this.$API
        .get("getlastest/A")
        .then((result) => {
          this.lastestData = result.data[0].newmessage.pm25;
          this.lastestDatapm10 = result.data[0].newmessage.pm10
            ? result.data[0].newmessage.pm10
            : 0;
          this.lastestAQI = this.mapData(this.lastestData, 0, 12, 0, 50);
        })
        .catch((err) => {
          console.log(err);
        });
      await this.$API
        .get("getair/A")
        .then((result) => {
          this.chart_data = result.data;
          this.selectDataA(this.selectData);
        })
        .catch((err) => {
          console.log(err);
        });
      this.$vs.loading.close();

      this.interval = setTimeout(() => {
        this.getData();
      }, 1000 * 60);
    },
    async selectDataA(item) {
      console.log(item);
      // var dataOne = [];
      // var dataOneLabel = [];
      // console.log(item.label);
      switch (item) {
        case 1:
          var dataOne = this.chart_data.daily.data;
          var dataOneLabel = this.chart_data.daily.timestamp;
          break;
        case 2:
          var dataOne = this.chart_data.monthly.data;
          var dataOneLabel = this.chart_data.monthly.timestamp;
          break;
        case 3:
          var dataOne = this.chart_data.yearly.data;
          var dataOneLabel = this.chart_data.yearly.timestamp;
          break;
        case 4:
          this.$refs["my-modal"].show();
          break;
        default:
          console.log("Try looking up for a hint.");
      }
      // dummy data
      // var data = [12, 19, 1, 14, 3, 10, 9];

      // var dataOne = item.value;
      var labels = dataOne.map((x, i) => i.toString());

      // other dataOne color
      var color = dataOne.map((x) => "rgba(128, 182, 244, 0.6)");

      // change max color
      color[this.argMax1(dataOne)] = "rgb(54, 162, 235, 0.75)";
      console.log("maxxxxxx" + this.argMax1(dataOne));
      this.datacollection = {
        labels: dataOneLabel,
        responsive: true,
        datasets: [
          {
            label: "PM2.5",
            backgroundColor: color,
            // backgroundColor: purple_orange_gradient,
            // hoverBackgroundColor: purple_orange_gradient,
            hoverBorderColor: "rgb(54, 162, 235, 0.75)",
            hoverBorderWidth: 2,

            // backgroundColor: gradientFill,
            borderWidth: 4,
            data: dataOne,
          },
        ],
      };
    },

    hideSideBar(id) {
      var element = document.getElementById(id);
      this.showIcon = false;
      // Supports most browsers and their versions.
      var requestMethod =
        element.requestFullScreen ||
        element.webkitRequestFullScreen ||
        element.mozRequestFullScreen ||
        element.msRequestFullScreen;

      if (requestMethod) {
        // Native full screen.
        requestMethod.call(element);
      } else if (typeof window.ActiveXObject !== "undefined") {
        // Older IE.
        var wscript = new ActiveXObject("WScript.Shell");
        if (wscript !== null) {
          wscript.SendKeys("{F11}");
        }
      }
      //       // Get the element that we want to take into fullscreen mode
      //   var element = document.getElementById(id);

      //   // These function will not exist in the browsers that don't support fullscreen mode yet,
      //   // so we'll have to check to see if they're available before calling them.

      //   if (element.mozRequestFullScreen) {
      //     // This is how to go into fullscren mode in Firefox
      //     // Note the "moz" prefix, which is short for Mozilla.
      //     element.mozRequestFullScreen();
      //   } else if (element.webkitRequestFullScreen) {
      //     // This is how to go into fullscreen mode in Chrome and Safari
      //     // Both of those browsers are based on the Webkit project, hence the same prefix.
      //     element.webkitRequestFullScreen();
      //  }
      // Hooray, now we're in fullscreen mode!
      // var x = window.matchMedia("(max-width: 1170px)");
      // console.log(x);
      // if (x.matches) {
      //   var elems = document.getElementsByClassName("main-container-fluid");
      //   Array.prototype.filter.call(elems, function (testElement) {
      //     testElement.style.padding = "0";
      //   });
      //   var elemnavbar = document.getElementsByClassName("vs-navbar");
      //   Array.prototype.filter.call(elemnavbar, function (testElement) {
      //     testElement.style.display = "none";
      //   });
      // } else {
      //   this.$store.commit("IS_SIDEBAR_ACTIVE", false);
      //   this.doNotClose = false;
      //   this.$store.commit("IS_HEADER_ACTIVE", false);
      //   document.getElementById("myDivCalen").style.marginLeft = "-260px";
      //   document.getElementById("myDivCalen").style.padding = "0";
      //   var elems = document.getElementsByClassName("main-container-fluid");
      //   Array.prototype.filter.call(elems, function (testElement) {
      //     testElement.style.padding = "0";
      //   });

      //   var elemnavbar = document.getElementsByClassName("vs-navbar");
      //   Array.prototype.filter.call(elemnavbar, function (testElement) {
      //     testElement.style.display = "none";
      //   });
      // }
    },
    showSideBar() {
      this.showIcon = true;
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        /* Safari */
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        /* IE11 */
        document.msExitFullscreen();
      }
    },

    argMax1(array) {
      console.log(array);
      return array
        .map((x, i) => [parseFloat(x), i])
        .reduce((r, a) => (a[0] > r[0] ? a : r))[1];
    },
    argMax2(array) {
      console.log(array);
      return array
        .map((x, i) => [parseFloat(x), i])
        .reduce((r, a) => (a[0] > r[0] ? a : r))[1];
    },
    fillData() {
      // dummy data
      // var data = [12, 19, 1, 14, 3, 10, 9];
      var dataOne = [120, 190, 199, 14, 200, 203, 33, 22, 100, 65, 10, 290];
      var dataTwo = [200, 101, 231, 14, 3, 20, 32, 22, 100];
      var labels = dataOne.map((x, i) => i.toString());

      // other dataOne color
      var color = dataOne.map((x) => "rgba(128, 182, 244, 0.6)");

      // change max color
      // color[this.argMax1(dataOne)] = "rgb(54, 162, 235, 0.75)";
      var labels = dataTwo.map((x, i) => i.toString());

      // other dataOne color
      var color2 = dataTwo.map((x) => "rgb(75, 192, 192, 0.75)");

      // change max color
      color2[this.argMax2(dataTwo)] = "#4FA3A3";
      this.datacollection = {
        labels: [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ],
        responsive: true,
        datasets: [
          {
            label: "2020",
            backgroundColor: color,
            // backgroundColor: purple_orange_gradient,
            // hoverBackgroundColor: purple_orange_gradient,
            hoverBorderColor: "purple",
            hoverBorderWidth: 2,

            // backgroundColor: gradientFill,
            borderWidth: 4,
            data: dataOne,
          },
          {
            label: "2021",
            data: dataTwo,
            backgroundColor: color2,
            borderWidth: 3,
          },
        ],
      };
      this.$refs["my-modal"].hide();
    },
    getRandomInt() {
      return Math.floor(Math.random() * (500 - 5 + 1)) + 5;
    },
  },
  async mounted() {
    this.$vs.loading();
    await this.getData();
    // this.fillData();
    this.call_graph(this.selectData);
    this.selectDataA(this.selectData);
  },
  beforeDestroy() {
    clearTimeout(this.interval);
  },

  computed: {
    visibleFields() {
      return this.fields.filter((field) => field.visible);
    },
    aqi_mode() {
      if (parseFloat(this.lastestAQI) > 300) {
        return "lv6";
      } else if (
        parseFloat(this.lastestAQI) <= 300 &&
        parseFloat(this.lastestAQI) > 200
      ) {
        return "lv5";
      } else if (
        parseFloat(this.lastestAQI) <= 200 &&
        parseFloat(this.lastestAQI) > 150
      ) {
        return "lv4";
      } else if (
        parseFloat(this.lastestAQI) <= 150 &&
        parseFloat(this.lastestAQI) > 100
      ) {
        return "lv3";
      } else if (
        parseFloat(this.lastestAQI) <= 100 &&
        parseFloat(this.lastestAQI) > 50
      ) {
        return "lv2";
      } else if (parseFloat(this.lastestAQI) <= 50) {
        return "lv1";
      }
    },
    myStyles() {
      return {
        // height: `${this.height}px`,
        position: "relative",
        color: "linear-gradient(#e66465, #9198e5)",
      };
    },
  },
};
</script>

<style scoped>
.small {
  max-width: 800px;
  height: 450px;
}
.inner-div1 {
  width: 100%;
  height: 100%;
  z-index: 1;
  /* margin: -15px; */
  /* margin-left: -15px; */
  padding: 5px 10px;
  margin-right: 0px;
  float: left;
  /* background : #337ab7; */
  background-image: url("../../../../assets/images/Enco/EnCo-Background01.jpeg");
  /* padding:500px 0px; */
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}
.hidden {
  display: inline-block;
}
div.con {
  background-image: url("../../../../assets/images/Enco/Rectangle -10.png");
  /* padding:500px 0px; */
}
.opacityCard {
  opacity: 0.8;
}
.a {
  background: #caebbd;
  padding: 5px;
  border-radius: 5px;

  height: 45%;
}
.b {
  background: #fbe988;
  padding: 5px;
  border-radius: 5px;
  height: 45%;
}
.w {
  background-image: url("../../../../assets/images/Enco/Rectangle 1718.png");
}
.bg-div2 {
  width: 100%;
  border-radius: 20px;
  height: 100%;
  text-align: center;
}
.ug-detail {
  margin-top: 1.3rem;
  margin-bottom: 0rem;
  font-size: 0.8rem;
}
/* @media only screen and (max-width: 600px) {
  .main-container-fluid {
    margin: 0;
  }
} */
.al-center {
  align-items: center;
}
.brdbtn {
  width: 80px;
  border-radius: 20px;
}
</style>
